import { useContext, useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Alert, Collapse, IconButton, useMediaQuery, useTheme } from "@mui/material";
import { styled } from "@mui/material/styles";
import { MobileNav } from "../mobile-nav";
import { SideNav } from "./side-nav";
import { TopNav } from "./top-nav";
import { useMobileNav } from "./use-mobile-nav";
import { HorizontalTabs } from "./horizontal-tabs";
import { useSections } from "../config";
import { Box } from "@mui/material";
import { SettingsContext } from "src/contexts/settings-context";
import {useSidebar} from "src/contexts/sidebar-context";
import GlassBackground from "src/components/GlassBackground";
import { mailBoxesApi } from "src/api/mailBoxes";
import { CloseOutlined } from "@mui/icons-material";

const SIDE_NAV_WIDTH = 270; //280

const VerticalLayoutRoot = styled("div")(({ theme, open, isNewInterfaceEnabled }) => ({
  display: "flex",
  flex: "1 1 auto",
  maxWidth: "100%",
  background: isNewInterfaceEnabled ? "transparent" : "rgba(248, 248, 249, 1)",
  padding: "8px",
  [theme.breakpoints.up("lg")]: {
    //paddingLeft: SIDE_NAV_WIDTH + 16,
    paddingLeft: open
      ? SIDE_NAV_WIDTH + 26
      : `calc(${theme.spacing(7)} + 27px)`,
  },
}));

const VerticalLayoutContainer = styled("div")(({alertOpen}) => ({
  position: "relative",
  display: "flex",
  flex: "1 1 auto",
  flexDirection: "column",
  width: "100%",
  // backgroundColor: "rgba(248, 248, 249, 1)",
  // border: "1px solid rgba(224, 224, 229, 1)",
  padding: "0px 8px",
  borderRadius: "16px",
  height: alertOpen ? "calc(100vh - 80px)" : "calc(100vh - 20px)",
  overflow: alertOpen ? "auto" : "unset"

}));

function debounce(func, wait) {
  let timeout;

  return function (...args) {
    const context = this;

    clearTimeout(timeout);
    timeout = setTimeout(() => {
      func.apply(context, args);
    }, wait);
  };
}

export const VerticalLayout = (props) => {
  const { children, sections, navColor } = props;
  const theme = useTheme();
  const lgUp = useMediaQuery((theme) => theme.breakpoints.up("lg"));
  const mobileNav = useMobileNav();
  const subSections = useSections(true);
  const [open, setOpen] = useState(false);
  const [flagSidebar, setFlagSidebar] = useState(false);
  const [imageIndex, setImageIndex] = useState(0);
  const images = [];
  const {isNewInterfaceEnabled} = useContext(SettingsContext);
  const [showBanner, setShowBanner] = useState(false);
  
  const {setSidebarOpen} = useSidebar();
  const email = sessionStorage.getItem("userEmail");
  //console.log(email, 'emailemailemailemail')
  const checkMigrationStatus = async () => {
    try {
      const data = await mailBoxesApi.getMigrationStatusMicrosoft({ email });
      setShowBanner(data)
    } catch (error) {
      
    }
  }
  const handleAlertClose = () => {
    setShowBanner(false);
  }


  useEffect(() => {
    debounce(() => {}, 1000);
    setOpen(flagSidebar);
    setSidebarOpen(flagSidebar);
    //checkMigrationStatus()
  }, [flagSidebar, setSidebarOpen]);
  const handleDrawerToggle = debounce((e, flag = null) => {
    if (flag === null) {
      setFlagSidebar(!flagSidebar);
    } else if (!flagSidebar && (flag === true || flag === false)) {
      //console.log({ flag });
      setOpen(flag);
    }
  }, 100);
  const getDomainFromLocation = () => {
  const domain = window.location.hostname;
  return domain;
  };

  const domain = getDomainFromLocation();
  const isB2bDomain = (domain === "app.b2brocket.ai" || domain === "qa.b2brocket.ai" || domain === "localhost");
  return (
    <>
      {/* {isNewInterfaceEnabled && (
         <>
          <Box
            id="background-overlay"
            sx={{
              position: "fixed",
              width: "100%",
              height: "100%",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundImage: (theme) =>
                theme.palette.mode === "dark"
                  ? "linear-gradient(180deg,hsla(0,0%,0%,0.4) 0%,hsla(0,0%,0%,0.1) 15%, hsla(0,0%,0%,0) 30%, hsla(0,0%,0%,0) 50%, hsla(0,0%,0%,0) 100%)"
                  : "linear-gradient(180deg,hsla(0,0%,100%,0.4) 0%,hsla(0,0%,100%,0) 100%)",
              backgroundSize: "cover",
              zIndex: "-1",
            }}
          >
          </Box>
          <Box className="glass-background-image">
            <img
              src={bg4}
              width="100%"
              height="100%"
            /> 
          </Box>
        </>
      )} */}
      

      {(isNewInterfaceEnabled && isB2bDomain) && <GlassBackground />}
      {!lgUp && <TopNav onMobileNavOpen={mobileNav.handleOpen} />}
      {/* {lgUp && <SideNav color={navColor} sections={sections} />} */}
      {lgUp && (
        <SideNav
          color={navColor}
          sections={sections}
          open={open}
          handleDrawerToggle={handleDrawerToggle}
        />
      )}
      {!lgUp && (
        <MobileNav
          color={navColor}
          onClose={mobileNav.handleClose}
          open={mobileNav.open}
          sections={sections}
        />
      )}
      {/* <Collapse in={showBanner}>
        <Alert 
          severity="warning" 
          variant="filled" 
          sx={{
              marginLeft: open
            ? `${SIDE_NAV_WIDTH + 30}px`
            : `calc(${theme.spacing(7)} + 30px)`,
            mt: 1.5,
            mr: 1.5,
            color: theme.palette.text.primary
          }}
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={handleAlertClose}
            >
              <CloseOutlined fontSize="inherit" />
            </IconButton>
          }
        >
          We’ve made some privacy & security updates—Please reconnect your Microsoft mailboxes to continue email sending.
        </Alert>
      </Collapse> */}
      <VerticalLayoutRoot open={open} isNewInterfaceEnabled={isNewInterfaceEnabled}>
        <VerticalLayoutContainer id="dashboard-content-root" alertOpen={false}>
          {/* <HorizontalTabs sections={subSections} /> */}
          {children}
        </VerticalLayoutContainer>
      </VerticalLayoutRoot>
    </>
  );
};

VerticalLayout.propTypes = {
  children: PropTypes.node,
  navColor: PropTypes.oneOf(["blend-in", "discreet", "evident"]),
  sections: PropTypes.array,
};
